import React from 'react';

const ProblemStatement = () => {
  return (
    <section className="py-16 md:py-24 bg-fordje-navy text-white border-t border-white/5">
      <div className="container-custom">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center max-w-6xl mx-auto">
          {/* Left: narrative */}
          <div className="lg:col-span-7">
            <h2 className="mb-10 animate-fade-in">
              Today, rejection is the <span className="gradient-text">discovery method.</span>
            </h2>

            <div
              className="space-y-6 text-lg md:text-xl text-fordje-gray leading-relaxed animate-fade-in"
              style={{ animationDelay: '0.1s' }}
            >
              <p className="text-white font-medium">
                Denied permits. Interconnection redlines. Failed inspections.
              </p>
              <p>
                Different symptoms, same problem: a requirement was buried, conflicting, or out of date.
              </p>
              <p>
                Then come the redesign, resubmittal, delayed PTO, or a project that no longer pencils.
              </p>
            </div>
          </div>

          {/* Right: stat anchor */}
          <div
            className="lg:col-span-5 animate-fade-in"
            style={{ animationDelay: '0.2s' }}
          >
            <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-8 md:p-10">
              <div className="text-6xl md:text-7xl lg:text-8xl font-bold gradient-text leading-none mb-6">
                29%
              </div>
              <p className="text-lg md:text-xl text-white leading-snug">
                of a residential system's cost is the labor, overhead, and delay around permitting and inspection — not the permit itself.
              </p>
              <cite className="mt-6 block text-sm text-fordje-gray not-italic tracking-wide">
                SEIA, Solar Soft Costs 2019
              </cite>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemStatement;
